import React from "react";
import { ToastContainer } from 'react-toastify';
import AsideRoutes from '../layouts/Aside/AsideRoutes';
import Wrapper from '../layouts/Wrapper/Wrapper';
import HeaderRoutes from '../layouts/Header/HeaderRoutes';
import Content from '../layouts/Content/Content';
import FooterRoutes from '../layouts/Footer/FooterRoutes';
import { Backtotop1 } from "../layouts/Backtotop/Backtotop";
import Rightside from "../layouts/Rightside/Rightside";
import Switcher from "../layouts/Switcher/Switcher";

const App = () => {
  document.querySelector("body").classList.remove("error-1");
  document.querySelector("body").classList.remove("app", "sidebar-mini", "landing-page", "horizontalmenu")
  document.querySelector("body").classList.add("main-body", "leftmenu")

  // const { pathname } = useLocation();
  // const navigate = useNavigate();
  // const userData = useSelector(state => state.userData);

  // useEffect(() => {
  //   console.log(pathname)
  //   console.log(layoutMenu.login.path)

  //   const user = (userData && userData.id)
  //   if (!user && pathname !== `${layoutMenu.login.path}`) {
  //     // console.log(pathname,layoutMenu.excelMap.path)
  //     navigate(`${layoutMenu.login.path}`);
  //   } else if (user && pathname === `${layoutMenu.login.path}`) {
  //     navigate(`/`);
  //   }

  // }, [pathname, userData, navigate]);

  return (
    <div className="app d-flex flex-column" style={{ flex: '1' }}>
      <Content />
      <ToastContainer />
    </div>
  );
};
export default App;
